import type { FC } from "react";
import { useDepartmentFlags } from "../../hooks/useDepartmentFlags";
import DemoHiringModule from "./DemoHiringModule";
import HiringModule from "./HiringPrediction/HiringModule";

const HiringModuleWrapper: FC = () => {
	const { isAnyDemo } = useDepartmentFlags();
	return isAnyDemo ? <DemoHiringModule /> : <HiringModule />;
};

export default HiringModuleWrapper;
